import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';

import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { GestorStatusService } from './gestor-status.service';
import * as backInter from 'app/auth/auth-data.model';

import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-gestor-status',
  templateUrl: './gestor-status.component.html',
  styleUrls: ['./gestor-status.component.scss'],
  animations : fuseAnimations
})
export class GestorStatusComponent implements OnInit {

  funciones: any[]= [];

  idEmpresa: string;
  nombreEmpresa: string;
  // productosEmpresa: backInter.infoProductos;

  constructor(
    private router: Router,
    private wizardService: WizardService,
    private gestorStatService: GestorStatusService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    // this.idEmpresa = this.router.getCurrentNavigation().extras.state.idEmpresa;
    this.idEmpresa = localStorage.getItem('empresaIDInfo');
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.obtieneProductos();
    //obtiene nombre empresa
    this.gestorStatService.getInfoEmpresa(this.idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      this.nombreEmpresa = data.data.nombreEmpresa;
    });
  }

  obtieneProductos(){
    this.wizardService.getProductosEmpresa(this.idEmpresa).subscribe( (respuesta: backInter.infoProductos) => {
      // this.productosEmpresa = respuesta;
      this.funciones.push(
        {
          id: 'CERTIFICAR',
          slug: 'certify',
          category: 'CGO',
          icon: 'bubble_chart',
          imagen: 'res-cert',
          numero: respuesta.productosCertificar.length
        }
      );
      this.funciones.push(
        {
          id: 'MEDIR',
          slug: 'measurement',
          category: 'CGO',
          icon: 'bubble_chart',
          imagen: 'res-med',
          numero: respuesta.productosMedir.length
        }
      );
      this.funciones.push(
        {
          id: 'PULSE',
          slug: 'pulse',
          category: 'CGO',
          icon: 'bubble_chart',
          imagen: 'res-pc',
          numero: respuesta.productosPulseCheck.length
        }
      );
    });
  }

  accesoProducto(producto:string) {
    let productosFiltrados: any[] = [];
    // switch(producto){
    //   case 'certify': productosFiltrados = this.productosEmpresa.productosCertificar; break;
    //   case 'measurement': productosFiltrados = this.productosEmpresa.productosMedir; break;
    //   case 'pulse': productosFiltrados = this.productosEmpresa.productosPulseCheck; break;
    //   case 'focus': productosFiltrados = this.productosEmpresa.productosFocusArea; break;
    // }
    localStorage.setItem('tipoProdInfo',producto);
    this.router.navigate(['/companies/status/'+producto], { state: {idEmpresa:this.idEmpresa, productosFiltrados, producto} });
  }

}
